import { useDispatch, useSelector } from "app/hooks";
import { personaliseReportActions } from "../../../app/features/personaliseReport/personaliseReportSlice";

export const useSectionListItem = (
  key: string
): { value: boolean; handleOnChange: Function } => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.personaliseReport);

  const handleOnChange = (value: boolean) => {
    console.log("key", key);
    dispatch(
      personaliseReportActions.updateReportSection({ section: key, value })
    );
  };

  return {
    value: !!(state as any)[key],
    handleOnChange,
  };
};
